export enum ActionTypeEnum {
  email = 'EMAIL',
  message = 'MESSAGE',
  invite = 'INVITE',
  inMail = 'INMAIL',
  freeInmail = 'FREE_INMAIL'
}
